import React from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail, FiArrowRight } from 'react-icons/fi';
import { FaFacebookF, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-dark-800 text-white">
      <div className="py-12 md:py-20 pb-10 md:pb-16">
        <div className="container">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {/* Company Info */}
            <div>
              <div className="flex items-center gap-3 mb-5">
                <img 
                  src="/NathKrupaLogo.jpeg" 
                  alt="Nath Krupa Energy" 
                  className="h-12 md:h-14 w-auto object-contain"
                />
              </div>
              <p className="text-white/70 leading-relaxed mb-6">
                Leading provider of renewable energy solutions in India. We are committed to 
                delivering sustainable solar solutions that power homes, businesses, and agriculture.
              </p>
              <div className="flex gap-3">
                <a href="https://www.facebook.com/profile.php?id=100067472019871" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 bg-white/10 flex items-center justify-center text-white hover:bg-solar-500 transition-colors rounded-lg">
                  <FaFacebookF />
                </a>
                <a href="https://www.linkedin.com/company/nathkrupa-energy-pvt-ltd/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-10 h-10 bg-white/10 flex items-center justify-center text-white hover:bg-solar-500 transition-colors rounded-lg">
                  <FaLinkedinIn />
                </a>
                <a href="https://www.instagram.com/nathkrupa_energy_pvt.ltd/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 bg-white/10 flex items-center justify-center text-white hover:bg-solar-500 transition-colors rounded-lg">
                  <FaInstagram />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-bold uppercase tracking-wide mb-6 pb-3 border-b-2 border-solar-500 inline-block">Quick Links</h3>
              <ul className="space-y-3">
                <li><Link to="/" className="flex items-center gap-2 text-white/70 hover:text-solar-400 hover:pl-1 transition-all"><FiArrowRight className="text-xs" /> Home</Link></li>
                <li><Link to="/about" className="flex items-center gap-2 text-white/70 hover:text-solar-400 hover:pl-1 transition-all"><FiArrowRight className="text-xs" /> About Us</Link></li>
                <li><Link to="/products" className="flex items-center gap-2 text-white/70 hover:text-solar-400 hover:pl-1 transition-all"><FiArrowRight className="text-xs" /> Products</Link></li>
                <li><Link to="/services" className="flex items-center gap-2 text-white/70 hover:text-solar-400 hover:pl-1 transition-all"><FiArrowRight className="text-xs" /> Services</Link></li>
                <li><Link to="/contact" className="flex items-center gap-2 text-white/70 hover:text-solar-400 hover:pl-1 transition-all"><FiArrowRight className="text-xs" /> Contact Us</Link></li>
              </ul>
            </div>

            {/* Products */}
            <div>
              <h3 className="text-lg font-bold uppercase tracking-wide mb-6 pb-3 border-b-2 border-solar-500 inline-block">Our Products</h3>
              <ul className="space-y-3">
                <li><Link to="/products" className="flex items-center gap-2 text-white/70 hover:text-solar-400 hover:pl-1 transition-all"><FiArrowRight className="text-xs" /> Solar Water Pump</Link></li>
                <li><Link to="/products" className="flex items-center gap-2 text-white/70 hover:text-solar-400 hover:pl-1 transition-all"><FiArrowRight className="text-xs" /> Solar Rooftop Systems</Link></li>
                <li><Link to="/products" className="flex items-center gap-2 text-white/70 hover:text-solar-400 hover:pl-1 transition-all"><FiArrowRight className="text-xs" /> Solar Panels</Link></li>
                <li><Link to="/products" className="flex items-center gap-2 text-white/70 hover:text-solar-400 hover:pl-1 transition-all"><FiArrowRight className="text-xs" /> Solar Inverters</Link></li>
                <li><Link to="/products" className="flex items-center gap-2 text-white/70 hover:text-solar-400 hover:pl-1 transition-all"><FiArrowRight className="text-xs" /> Solar Controllers</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-bold uppercase tracking-wide mb-6 pb-3 border-b-2 border-solar-500 inline-block">Contact Info</h3>
              <ul className="space-y-5">
                <li className="flex gap-4">
                  <FiMapPin className="text-xl text-solar-400 mt-1 flex-shrink-0" />
                  <span className="text-white/70">Metro Complex, Kuldharan Road,<br />Karjat, Dist. Anagar, Maharashtra 414402</span>
                </li>
                <li className="flex gap-4">
                  <FiPhone className="text-xl text-solar-400 mt-1 flex-shrink-0" />
                  <div className="flex flex-col">
                    <a href="tel:1800 233 2727" className="text-white/70 hover:text-solar-400 transition-colors">1800 233 2727</a>
                  </div>
                </li>
                <li className="flex gap-4">
                  <FiMail className="text-xl text-solar-400 mt-1 flex-shrink-0" />
                  <div className="flex flex-col">
                    <a href="mailto:nathkrupaenergy@gmail.com" className="text-white/70 hover:text-solar-400 transition-colors">nathkrupaenergy@gmail.com</a>
                    <a href="mailto:nathkrupaenterprises27@gmail.com" className="text-white/70 hover:text-solar-400 transition-colors">nathkrupaenterprises27@gmail.com</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="bg-dark-900 py-5">
        <div className="container flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/60 text-sm">&copy; {new Date().getFullYear()} Nath Krupa Energy. All Rights Reserved.</p>
          <p className="text-white/60 text-sm">Powered by <a href="https://balsoordigital.in/" target="_blank" rel="noopener noreferrer" className="text-solar-400 hover:text-solar-300 transition-colors">Balsoor Digital</a></p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-white/60 text-sm hover:text-solar-400 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-white/60 text-sm hover:text-solar-400 transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
